import { useTranslation } from 'react-i18next'

import { cn } from '#/shared/lib/utils'

import {
  campaignStatusLabelKey,
  campaignStatusTone,
} from '../lib/campaign-status'
import type { CampaignStatus } from '../model/campaign'

interface CampaignStatusPillProps {
  status: CampaignStatus
  className?: string
}

export function CampaignStatusPill({
  status,
  className,
}: CampaignStatusPillProps) {
  const { t } = useTranslation()
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.75 text-xs font-medium',
        campaignStatusTone(status),
        className,
      )}
    >
      {t(campaignStatusLabelKey(status))}
    </span>
  )
}
